module.exports = __webpack_public_path__ + "static/ic-luka-fd0bbdd490d8489eeccce2d765594fb9.png";